import { render } from "./TeamSidebar.vue?vue&type=template&id=03956aa6&scoped=true"
import script from "./TeamSidebar.vue?vue&type=script&lang=js"
export * from "./TeamSidebar.vue?vue&type=script&lang=js"

import "./TeamSidebar.vue?vue&type=style&index=0&id=03956aa6&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03956aa6"]])

export default __exports__